import { c, t } from "ttag";

import { Link } from "metabase/common/components/Link";
import { Box, Button, Flex, Icon, Text } from "metabase/ui";
import { color } from "metabase/ui/colors";
import type { CloudMigration } from "metabase-types/api/cloud-migration";

import { LargeIconContainer, MigrationCard } from "./CloudPanel.styled";
import { getMigrationEventTime } from "./utils";

interface MigrationErrorProps {
  migration: CloudMigration;
  restartMigration: () => void;
  isRestarting: boolean;
}

export const MigrationError = ({
  migration,
  restartMigration,
  isRestarting,
}: MigrationErrorProps) => {
  const failedAt = getMigrationEventTime(migration.updated_at);

  return (
    <>
      <MigrationCard>
        <Flex gap="md">
          <LargeIconContainer color={color("error")}>
            <Icon size="1.5rem" name="warning" />
          </LargeIconContainer>
          <Box>
            <Text fw="bold">{t`Migration to Metabase Cloud failed`}</Text>
            <Text mt="1rem">
              {c("{0} is an email address")
                .jt`Please try again later, and reach out to us at ${
                /* eslint-disable i18next/no-literal-string */
                (
                  <Link
                    key="email"
                    variant="brand"
                    to="mailto:help@metabase.com"
                  >
                    help@metabase.com
                  </Link>
                )
                /* eslint-enable i18next/no-literal-string */
              } if you need help.`}
            </Text>
            <Text
              size="sm"
              mt=".5rem"
            >{t`Migration to Metabase Cloud failed on ${failedAt}.`}</Text>
          </Box>
        </Flex>
      </MigrationCard>

      <Button
        variant="subtle"
        onClick={restartMigration}
        disabled={isRestarting}
        px="0"
        mt="1rem"
      >{t`Restart the process`}</Button>
    </>
  );
};
